<template>
    <div class="vuetable-filterbar col-md-12">
	    <div class="form-group p-l">
            <b-container fluid class="p-a-0">
                <b-row no-gutters>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <vue-tags-input
                              v-model="num_pedido"
                              :tags="num_pedidos"
                              :placeholder="placeholder_empty"
                              @tags-changed="newTags => num_pedidos = newTags"
                            />
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">N° Pedido</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <vue-tags-input
                              v-model="num_uc"
                              :tags="num_ucs"
                              :placeholder="placeholder_empty"
                              @tags-changed="newTags => num_ucs = newTags"
                            />
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">N° UC</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <vue-tags-input
                              v-model="tom_cnpj"
                              :tags="tom_cnpjs"
                              :placeholder="placeholder_empty"
                              @tags-changed="newTags => tom_cnpjs = newTags"
                            />
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">CNPJ Tomador</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="1" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <!--<v-date-picker v-model="dt_inicio"
                                           mode='single'
                                           locale="pt-BR"
                                           v-mask="'##/##/####'"
                                           :popover='{visibility: "focus"}'
                                           :attributes='date_attributes'
                                           :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'
                                           @keyup.enter="doFilter">
                            </v-date-picker>-->
                            <div class="fl-flex-label fl-collapsed fl-background">
                                <input v-mask="'##/##/####'" type="text" class="form-control" v-model="dt_inicio" @keyup.enter="doFilter">
                                <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Data Inicio</label>
                            </div>
                        </div>
                    </b-col>
                    <b-col sm="6" md="1" class="m-t-5px p-a-0">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <!--<v-date-picker v-model="dt_fim"
                                           mode='single'
                                           locale="pt-BR"
                                           v-mask="'##/##/####'"
                                           :popover='{visibility: "focus"}'
                                           :attributes='date_attributes'
                                           :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'
                                           @keyup.enter="doFilter">
                            </v-date-picker>-->
                            <div class="fl-flex-label fl-collapsed fl-background">
                                <input v-mask="'##/##/####'" type="text" class="form-control" v-model="dt_fim" @keyup.enter="doFilter">
                                <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">Data Fim</label>
                            </div>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <div class="fl-flex-label fl-collapsed fl-background">
                            <input type="text" class="form-control" v-model="for_cnpj" @keyup.enter="doFilter">
                            <label class="fl-label" for="default-input" style="left: 13px; right: 12px;">CNPJ Fornecedor</label>
                        </div>
                    </b-col>
                    <b-col sm="6" md="2" class="p-a-0 m-t-5px">
                        <multiselect v-model="status"
                        :options="optionsLivStatus"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Status"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        ></multiselect>
                    </b-col>
                    <b-col sm="6" md="2" class="m-t-5px">
                        <div class="input-group-btn">
                            <div class="btn-group">
                                <button type="button" class="btn btn-secondary btn-outline" @click="doFilter" :disabled="vuetableFilterButton">Filtrar</button>
                                <button type="button" class="btn btn-secondary btn-outline" @click="resetFilter" :disabled="vuetableFilterButton">Limpar</button>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import VueTagsInput from '@johmun/vue-tags-input';
import moment from 'moment'

export default {
  components: {
      Multiselect,
      VueTagsInput,
  },
  data () {
    return {
        date_attributes: [{key: 'today',highlight: true,dates: new Date()}],
      helpForm: new Form({params: []}),
      placeholder_empty: '',
      num_pedido: '',
      num_pedidos: [],
      num_uc: '',
      num_ucs: [],
      tom_cnpj: '',
      tom_cnpjs: [],
      dt_inicio: '',
      dt_fim: '',
      for_cnpj: '',
      optionsLivStatus: [],
      status: [],
      data_filter: []
    }
  },
  mounted() {
      this.getStatus();
    },
  methods: {
      doFilter () {
          this.$store.commit('setVuetableFilterButton', true);
          this.dt_inicio = this.formatDateSubmit(this.dt_inicio);
          this.dt_fim = this.formatDateSubmit(this.dt_fim);
          this.data_filter = {num_pedidos: this.num_pedidos,
                              num_ucs: this.num_ucs,
                              tom_cnpjs: this.tom_cnpjs,
                              for_cnpj: this.for_cnpj,
                              dt_fim: this.dt_fim,
                              dt_inicio: this.dt_inicio,
                              status: this.status}
          this.$events.fire('filter-set', this.data_filter);
      },
      resetFilter () {
        this.num_pedidos = null;
        this.num_pedidos = [];
        this.num_ucs = null;
        this.num_ucs = [];
        this.tom_cnpj = '';
        this.tom_cnpjs = [];
        this.for_cnpj = null;
        this.dt_inicio =  '';
        this.dt_fim = '';
        this.status = '';
        this.$events.fire('filter-reset');
      },
      formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
          return (value == null || value == "")
            ? ''
            : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
      },
      getStatus() {
          this.helpForm.params = { tabela: 'pedido',
                                  coluna: 'status' };

          this.helpForm.get('/api/listitemvalor/jsonlist').then(response =>
          {
              new ReturnApi(response, this, true, false, false);
              response.items.forEach((obj)=>
              {
                  this.optionsLivStatus.push({ label: obj.descr, value: obj.valor })
              });
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this, true, false, false)
          });
      }
  },
  computed: {
    vuetableFilterButton: {
      get () {
        return this.$store.state.vuetable.filterButton;
      },
     },
    }
}
</script>
<style lang="css">

.vue-tags-input .input {
  padding: 0px !important;
  border: none;
  border: solid 1px rgba(197, 214, 222, 0.7) !important;
  border-radius: .25rem !important;
}

.tags {
    padding-top: 13px !important;
}
.tag {
  position: relative;
  padding: 1px 2px !important;
  margin-top: 5px !important;
}

.tag.valid {
  background-color: #04B404 !important;
  font-size: .65em !important;
}


</style>
